import { Injectable } from '@angular/core';
import {ApiService} from "../../../../services/external-api/api.service";
import {SpinnerService} from "@retail-data-factory/rdf-angular-utils";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {logger} from "@retail-data-factory/rdf-angular-utils";
import {catchError, finalize, map} from "rxjs/operators";
import {throwError} from "rxjs";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {Presenter} from "../../../internal/presenter/presenter";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";


type ReportType = 'tasks';
@Injectable({
  providedIn: 'root'
})
export class TasksService {

  constructor(private apiService: ApiService,  private spinnerService: SpinnerService, private http: HttpClient, public presenter: Presenter, private configurationManager: ConfigurationManager){

  }
  getData(type:ReportType, param?: object) {
    this.spinnerService.show();
    const requestParameters = {};
    requestParameters['access_token'] = this.presenter.accessToken;

    let service = '';
    switch (type) {
      case 'tasks':
        service = '/tasks';
        requestParameters['datefrom'] = param['FromDate'];
        requestParameters['dateuntil'] = param['ToDate'];
        break;

    }

    logger.print(`Report app, requesting get data service, (type - ${type}, apiUrl - ${this.configurationManager.getApiUrl('apiPlatformUrl')}, service - ${service}) parameters:`, 'webService');
    console.log(requestParameters);

    return this.apiService.get(this.configurationManager.getApiUrl('apiPlatformUrl') + service, requestParameters).pipe(
      map((result: IServiceResponse) => {
        logger.print(`Report app, requesting get data service, (type - ${type}, apiUrl - ${this.configurationManager.getApiUrl('apiPlatformUrl')},service - ${service}) result:`, 'webService');
        console.log(result);
        if (!result.Error && result.report) {
          return { data: result.report, type: type };
        }
        return throwError('error in service response');  //Observable.throw('error in service response');
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('request error', error);
        if (error.status === 401) {
          this.presenter.logout();
        }
        return  throwError(error || 'backend server error'); //Observable.throw(error || 'backend server error');
      }),
      finalize(() => this.spinnerService.hide())
    );

  }

  getReportFile(rid: string, datasourcePartyId: string) {
    const requestParameters = {};
    requestParameters['access_token'] =  this.presenter.accessToken;
    requestParameters['access-token'] =  this.presenter.accessToken;
    requestParameters['datasourcepartyid'] =  datasourcePartyId;
    return this.apiService.get(this.configurationManager.getApiUrl('apiReportingUrl') + '/tasks/' + rid + '/files', requestParameters);
  }
}
